module.exports = __webpack_public_path__ + "img/albania.c2b05705.svg";